// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mo-c";
export var backButton = "_mo-4";
export var backIcon = "_mo-5";
export var chevronShortcut = "_mo-6";
export var container = "_mo-1";
export var editor = "_mo-8";
export var editorWrapper = "_mo-7";
export var prefix = "_mo-2";
export var searchIcon = "_mo-3";
export var suffix = "_mo-9";
export var suffixContent = "_mo-a";
export var suffixText = "_mo-b";
export var wrapper = "_mo-0";